import http from './utils';
import { prefix, mockPrefix } from './constants';

// 主页顶层filter-时间下拉框
export function getWeekly_OverView_EffectiveTimeList(payload: any) {
  return http({
    url: `${prefix}/weekly_report/overview/overview_summary/list`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
}

// 核心概览富文本-获取内容
export function getWeekly_OverView_getRichText(payload: any) {
  return http({
    url: `${prefix}/weekly_report/overview/overview_summary/detail`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
}
// 核心概览富文本-编辑
export function getWeekly_OverView_editRichText(payload: any) {
  return http({
    url: `${prefix}/weekly_report/overview/overview_summary/update`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
}

// 核心指标周度追踪-table
export function getWeekly_OverView_KeyMetricsTable(payload: any) {
  return http({
    url: `${prefix}/weekly_report/overview/overview_stat/list`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
}

// 核心指标周度追踪-Chart
export function getWeekly_OverView_KeyMetricsChart(payload: any) {
  return http({
    url: `${prefix}/weekly_report/overview/overview_stat/timeline`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
}

// 渠道排名周度追踪
export function getWeekly_OverView_ChannelRank(payload: any) {
  return http({
    url: `${prefix}/weekly_report/overview/ranking/list`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
}

// 下转页-相对周均表现-Channel图表
export function getWeekly_OverView_ChannelChart(payload: any) {
  return http({
    url: `${prefix}/weekly_report/overview/overview_stat/channel`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
}

// 下转页-相对周均表现-Language图表
export function getWeekly_OverView_LanguageChart(payload: any) {
  return http({
    url: `${prefix}/weekly_report/overview/overview_stat/language`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
}

export function getWeeklyRichEditPermissions(payload: any) {
  return http({
    url: `${prefix}/weekly_report/perm/weekly_permissions`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
}
